import { useSelector } from 'react-redux';
import { formatAmount } from '../../helpers/format';
import { selectDesiredCreditsAmount } from '../../store/account/selectors';
import CreditsAmountSlider from '../MyApps/components/CreditsAmountSlider';
import PurchaseCredits from './components/PurchaseCredits';
import PurchaseSubscription from './components/PurchaseSubscription';
import ContentBlock from './components/ContentBlock';
import {
  StyledDescription,
  StyledHeader,
  StyledInner,
  StyledPriceBoxesWrapper,
  StyledSliderContent,
  StyledSliderHeader,
  StyledSliderQuantity,
  StyledSliderQuantityText,
  StyledSliderQuantityWrapper,
  StyledSliderWrapper,
  StyledWrapper,
} from './styled';
import HeadMetaData from '../HeadMetaData';
import { meta } from '../../metaInfo';

const Pricing = () => {
  const quantity = useSelector(selectDesiredCreditsAmount);
  return (
    <>
      <HeadMetaData
        title={meta.pricing.title}
        description={meta.pricing.description}
      />
      <StyledWrapper>
        <StyledInner>
          <StyledHeader>Creative AI music platform for developers</StyledHeader>
          <StyledDescription>
            High-speed AI music generation for your products. Flexible pricing
            as you scale. 100% copyright-safe.
          </StyledDescription>
          <StyledSliderWrapper>
            <StyledSliderHeader title="How many track generations do you need?"></StyledSliderHeader>
            <StyledSliderContent>
              <CreditsAmountSlider />
              <StyledSliderQuantityWrapper>
                <StyledSliderQuantity>
                  {formatAmount(quantity)}
                </StyledSliderQuantity>
                <StyledSliderQuantityText>
                  track generations
                </StyledSliderQuantityText>
              </StyledSliderQuantityWrapper>
            </StyledSliderContent>
          </StyledSliderWrapper>
          <StyledPriceBoxesWrapper>
            <PurchaseCredits />
            <PurchaseSubscription />
          </StyledPriceBoxesWrapper>
          <ContentBlock />
        </StyledInner>
      </StyledWrapper>
    </>
  );
};

export default Pricing;
